import { render, staticRenderFns } from "./AssetsCreation.vue?vue&type=template&id=3a868395&scoped=true&"
import script from "./AssetsCreation.vue?vue&type=script&lang=js&"
export * from "./AssetsCreation.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCreation.vue?vue&type=style&index=0&id=3a868395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a868395",
  null
  
)

export default component.exports